import { createTestListTypes } from '../../../common/test-list/types';

export const NAMESPACE = 'analytics-test-history-test-list-rdc';
export default createTestListTypes(NAMESPACE);
